import type { SubmitHandler } from 'react-hook-form';
import { useState } from 'react';

import type { IContainerProps } from '~/components/utils/Container';
import type { IApiCreateIapPollResponseBody } from '~/lib/api/modules/IapPolls';
import type { IUseCreateIapPollMutationValues } from '~/lib/api/modules/IapPolls/hooks/useCreateIapPollMutation';
import type { IIapPollFormValues } from './IapPollForm';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { useCreateIapPollMutation } from '~/lib/api/modules/IapPolls/hooks/useCreateIapPollMutation';
import { IapPollForm } from './IapPollForm';

export type ICreateIapPollFormProps = IContainerProps & {
  onSuccess?: (
    outputData: IApiCreateIapPollResponseBody,
    inputValues: IUseCreateIapPollMutationValues,
  ) => void;
  cancelUrl?: string;
  appId: string;
};

export const CreateIapPollForm: React.FC<ICreateIapPollFormProps> = (props) => {
  const { sx, onSuccess, cancelUrl, appId } = props;
  const createIapPollMutation = useCreateIapPollMutation();
  const [disabled, setDisabled] = useState(false);

  const handleSubmit: SubmitHandler<IIapPollFormValues> = (values) => {
    if (createIapPollMutation.isLoading) {
      return;
    }

    return createIapPollMutation.mutateAsync(
      {
        appId,
        body: {
          active: !values.inactive,
          description: values.description!,
          displayResults: !!values.displayResults,
          endDate: values.endDate!,
          options: values.options!.map((option) => ({
            priceId: option.priceId ?? '',
            points: option.points!,
            maxVotesPerUserPerArticle: option.maxVotesPerUserPerArticle ?? 0,
          })),
          startDate: values.startDate!,
          title: values.title!,
        },
      },
      { onSuccess },
    );
  };

  return (
    <ContentBlock draft={disabled} sx={sx} draftOutlineSize="lg">
      <IapPollForm
        mode="creation"
        cancelUrl={cancelUrl}
        onSubmit={handleSubmit}
        onDisabledStatusChange={setDisabled}
        defaultValues={{
          displayResults: true,
          startDate: new Date().toISOString(),
        }}
        first
      />
    </ContentBlock>
  );
};
